import { render, staticRenderFns } from "./ListSeguroincendioApolicePage.vue?vue&type=template&id=96c90d4e&"
import script from "./ListSeguroincendioApolicePage.vue?vue&type=script&lang=js&"
export * from "./ListSeguroincendioApolicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports